import {carModificationTypes, YES_NO_CHOICE_OPTIONS} from "@constants/dropdown-choices";
import ButtonGroup from "@components/common/form-controls/button-group";
import DropDown from "@components/common/form-controls/drop-down";
import RequiredSign from "@components/common/ui-elements/required-sign";
import ScrollableButtonGroupBlock from "@components/common/form-blocks/scrollable/button-group-block";
import ScrollableDropdownBlock from "@components/common/form-blocks/scrollable/dropdown-block";
import ScrollableTextBoxBlock from "@components/common/form-blocks/scrollable/text-box-block";

export default function CarModifications(
    {
        data = {},
        handlers,
        setCurrentStep
    }
) {

    return (
        <div className="car-modifications">


            <div className="row">

                {/* Does the car have any modifications? */}

                <ScrollableButtonGroupBlock
                    containerCssClass="col-12 py-3 "
                    labelText="Does the car have any modifications?"
                    required={true}
                    controlName="hasModifications"
                    options={YES_NO_CHOICE_OPTIONS}
                    selectedValues={data.hasModifications}
                    onChange={handlers.onControlChange}
                />

            </div>

            {/* hasModifications */}

            {data.hasModifications === 'Yes' && (

                <div className="hidden-box row">

                    {/* What type of modification? */}

                    <ScrollableDropdownBlock
                        controlName="modificationType"
                        containerCssClass="col-12 py-3 "
                        labelText="What type of modification?"
                        required={true}
                        options={carModificationTypes}
                        selectedValues={data.modificationType}
                        onChange={handlers.onControlChange}
                        helpText=""
                    />

                    {/*  What is the detail of the modification? */}

                    <ScrollableTextBoxBlock
                        containerCssClass="col-12 py-3 "
                        labelText=" What is the detail of the modification?"
                        required={true}
                        controlName="modificationDetails"
                        value={data.modificationDetails}
                        onChange={handlers.onControlChange}
                        inputAttrs={{
                            maxLength: 1024,
                            rows : 5
                        }}
                        asTextArea={true}
                    />

                </div>

            )}

        </div>
    );

}